var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"e-modal",class:_vm.modalClass},[_c('div',{staticClass:"e-modal__backdrop",on:{"click":function($event){return _vm.$emit('close')}}}),_c('div',{ref:"modalContainer",staticClass:"e-modal__container"},[(_vm.width)?_vm._t("container",null,{"size":_vm.width}):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }